// eslint-disable-line no-unused-vars
// eslint-disable-next-line no-unused-vars
import { boot } from 'quasar/wrappers'
import {
    isPermittedAction,
    isPermittedView,
    isPermitted,
    isLoggedIn,
} from 'src/js/userdata.js';

export default boot(({ app }) => {
    app.config.globalProperties.$userdata = {
        isPermittedAction,
        isPermittedView,
        isPermitted,
        isLoggedIn,
    }
});
